@if (!appSettings.isMobile()) {
    <div>
        <div class="row mb-3 align-items-end g-2">
            <div class="col-md-4">
                <label class="form-label small text-muted mb-1">Buscar</label>
                <input type="text" class="form-control" placeholder="Nombre, slug o abreviatura"
                    [(ngModel)]="searchText" (ngModelChange)="applyFilters()">
            </div>
            <div class="col-md-3">
                <label class="form-label small text-muted mb-1">Estado</label>
                <select class="form-select" [(ngModel)]="activeFilter" (ngModelChange)="applyFilters()">
                    <option [ngValue]="null">Todas</option>
                    <option [ngValue]="true">Activas</option>
                    <option [ngValue]="false">Inactivas</option>
                </select>
            </div>
            <div class="col-md-5 d-flex justify-content-end">
                <ng-content></ng-content>
            </div>
        </div>

        <div class="table-responsive table-data mb-3">
            <table class="table table-hover table-sm align-middle">
                <thead>
                    <tr>
                        <th role="button" (click)="orderCol('slug')">Slug</th>
                        <th role="button" (click)="orderCol('name')">Nombre</th>
                        <th role="button" (click)="orderCol('abbr')">Abrev.</th>
                        <th>Icono</th>
                        <th role="button" (click)="orderCol('isActive')">Activa</th>
                        <th class="text-end"><i class="fas fa-cog"></i></th>
                    </tr>
                </thead>
                <tbody>
                    @if (isLoading) {
                        @for (i of rows; track $index) {
                            <tr class="tr-custom">
                                @for (c of [1,2,3,4,5,6]; track c) {
                                    <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                                }
                            </tr>
                        }
                    }

                    @for (cat of filteredCategories; track cat.uuid) {
                        <tr [class.table-active]="selectedUuid() === cat.uuid">
                            <td><code class="small">{{ cat.slug }}</code></td>
                            <td class="fw-semibold">{{ cat.name }}</td>
                            <td><span class="badge text-bg-light border">{{ cat.abbr || '-' }}</span></td>
                            <td>
                                @if (cat.icon) {
                                    <i [class]="cat.icon + ' text-secondary me-1'"></i>
                                    <small class="text-muted">{{ cat.icon }}</small>
                                } @else {
                                    <small class="text-muted">-</small>
                                }
                            </td>
                            <td>
                                <span class="badge" [class.text-bg-success]="cat.isActive !== false" [class.text-bg-secondary]="cat.isActive === false">
                                    {{ cat.isActive !== false ? 'Sí' : 'No' }}
                                </span>
                            </td>
                            <td class="text-end">
                                <div class="btn-group btn-group-sm">
                                    @if (perm.canCurrent('canUpdate')) {
                                    <button class="btn btn-outline-primary" title="Editar" (click)="selectCategory(cat)">
                                        <i class="fas fa-edit"></i>
                                    </button>
                                    }
                                    @if (perm.canCurrent('canDelete')) {
                                    <button class="btn btn-outline-danger" title="Eliminar" (click)="deleteCategory(cat)">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                    }
                                </div>
                            </td>
                        </tr>
                    }

                    @if (!isLoading && filteredCategories.length === 0) {
                        <tr>
                            <td colspan="6" class="text-center text-muted py-4">
                                <i class="fas fa-inbox fa-2x mb-2 d-block opacity-50"></i>
                                No se encontraron categorías
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
} @else {
    <app-mobile-footer>
        <input type="search"
               class="form-control mobile-footer-search"
               placeholder="Buscar nombre, slug o abreviatura..."
               [(ngModel)]="searchText"
               (ngModelChange)="applyFilters()">
        <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
                [class.btn-outline-primary]="activeFilter !== null"
                (click)="mobileFiltersOpen = true">
            <i class="fas fa-filter me-1"></i>Filtros
            @if (activeFilter !== null) {
                <span class="badge bg-primary ms-1">1</span>
            }
        </button>
    </app-mobile-footer>
    <app-bottom-sheet [open]="mobileFiltersOpen" title="Filtros" (closed)="mobileFiltersOpen = false">
        <div class="d-flex flex-wrap gap-2 px-3 pb-3">
            <span class="filter-badge"
                  role="button"
                  tabindex="0"
                  [class.active]="activeFilter === null"
                  (click)="setActiveFilter(null)">
                Todas
            </span>
            <span class="filter-badge"
                  role="button"
                  tabindex="0"
                  [class.active]="activeFilter === true"
                  (click)="setActiveFilter(true)">
                Activas
            </span>
            <span class="filter-badge"
                  role="button"
                  tabindex="0"
                  [class.active]="activeFilter === false"
                  (click)="setActiveFilter(false)">
                Inactivas
            </span>
        </div>
    </app-bottom-sheet>

    <div class="d-flex justify-content-between align-items-center mb-2 px-1">
        <span class="small text-muted fw-bold text-uppercase">
            REGISTROS @if (!isLoading) { ({{ filteredCategories.length }}) }
        </span>
    </div>

    <div class="mobile-cards-scroll">
        @if (isLoading) {
            @for (i of rows; track $index) {
                <app-list-card [isLoading]="true"></app-list-card>
            }
        } @else {
            @for (cat of filteredCategories; track cat.uuid) {
                <app-list-card
                    [isShortcut]="true"
                    (click)="selectCategory(cat)">
                    <div cardTitle class="fw-bold text-dark text-truncate">
                        <i [class]="(cat.icon || 'fas fa-folder') + ' me-1 text-secondary'"></i>
                        {{ cat.name }}
                    </div>
                    <div cardBadge>
                        <span class="badge" [class.text-bg-success]="cat.isActive !== false" [class.text-bg-secondary]="cat.isActive === false">
                            {{ cat.isActive !== false ? 'Activa' : 'Inactiva' }}
                        </span>
                    </div>

                    <div class="row g-1 text-muted small">
                        <div class="col-7">
                            <span class="text-muted">Slug</span>
                            <div><code class="small">{{ cat.slug }}</code></div>
                        </div>
                        <div class="col-5 text-end">
                            <span class="text-muted">Abrev.</span>
                            <div class="fw-semibold text-dark">{{ cat.abbr || '—' }}</div>
                        </div>
                    </div>
                </app-list-card>
            }
        }

        @if (!isLoading && filteredCategories.length === 0) {
            <div class="card border-0 shadow-sm p-4 text-center my-2">
                <i class="fas fa-folder-open fa-3x text-muted opacity-50 mb-2"></i>
                <h6 class="text-muted mb-1">Sin categorías</h6>
                <small class="text-muted">Ajusta los filtros o crea una nueva.</small>
            </div>
        }
    </div>
}
